module.exports = __webpack_public_path__ + "static/media/stage-product-icons-teammobil.b928331b.svg";